import { render } from "./homeservices-landing.vue?vue&type=template&id=23e08067"
import script from "./homeservices-landing.js?vue&type=script&lang=js"
export * from "./homeservices-landing.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__